import axios from 'axios';
import { I18n } from 'vue-i18n'
import moment from "moment";
export interface TranslationServiceType {
  i18n: I18n,
  refreshTranslation: Function
}
export default class TranslationService {
  private i18n: I18n;
  public refreshTranslation: Function;
  public language: string;
  constructor(i18n: I18n) {
    this.i18n = i18n;
    this.language = localStorage.getItem('PAI-language')||'zh_CN';
    // 本地开发环境使用  development
    this._init();
    // 打包线上环境使用  production
    this.refreshTranslation = (val: string, isInit = false) => {
      localStorage.setItem('PAI-language', val);
      this.language = val;
      return this._setTranslation(val,isInit);
    }
  }
  private async _init() {
    if (process.env.NODE_ENV === 'development') {
      const zhCN = await import('@/global/i18n/lang-pack/zh-CN');
      const EN = await import('@/global/i18n/lang-pack/en');
      this.i18n.global.setLocaleMessage('zh-CN', zhCN.default);
      this.i18n.global.setLocaleMessage('en', EN.default);
    }
  }
  private _setTranslation(language: string, isInit:boolean): void {
    if (language === 'zh_CN' || language === 'zh_TW') {
      language = language.replace('_', '-');
    }
    localStorage.setItem('lang', language);
    if(language === 'en'){
      moment.locale('en');
    }else{
      moment.locale('zh-cn');
    }
    const message = this.i18n.global.getLocaleMessage(language)
    const keys = Object.keys(message)
    if (!message || !keys || keys.length === 0) {
      // 多语言
      const langData = {}; 
      // if (process.env.NODE_ENV === 'production') {
        const url = `${process.env.VUE_APP_BASE}i18n/${language}.json`
        axios.get(url).then(res => {
          if (res.data) {
            // 添加 多语言
            this.i18n.global.setLocaleMessage(language, Object.assign(langData, res.data));
            if(!isInit){
              location.reload()
            }
          }
        });
      // }
    }else{
      if(!isInit){
        location.reload()
      }
    }
  }
}
